// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import ProjectEditScreen from "../../src/screens/projects/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} ProjectNewRouteProps */

/** @typedef {Record<string, never>} ProjectNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<ProjectNewRouteProps, ProjectNewRouteState>}
 */
class ProjectNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New project")}</ScreenTitle>
        <ProjectEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<ProjectNewRouteProps>} */
const ProjectNewRouteComponent = memo(shapeComponent(ProjectNewRoute))

export default ProjectNewRouteComponent
